var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"mobile":_vm.$store.state.MobileStatue}}),_vm._v(" "),_c('router-view',{attrs:{"mobile":_vm.$store.state.MobileStatue}}),_vm._v(" "),_c('Footer',{attrs:{"mobile":_vm.$store.state.MobileStatue}}),_vm._v(" "),_c('CookieConsentTool',{ref:"cookieConsentTool"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d13395ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 